export const CREATE_EXHIBITION_CATEGORY = `
  mutation createExhibitionCategory($input: CreateExhibitionCategoryInput!, $tenant_id: Int!) {
    createExhibitionCategory(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionCategory {
        id
        name
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_EXHIBITION_CATEGORY = `
  mutation updateExhibitionCategory($input: UpdateExhibitionCategoryInput!, $tenant_id: Int!) {
    updateExhibitionCategory(input: $input, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionCategory {
        id
        name
        is_active
        vistage20_id
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_EXHIBITION_CATEGORY = `
  mutation deleteExhibitionCategory($id: Int!, $tenant_id: Int!) {
    deleteExhibitionCategory(id: $id, tenant_id: $tenant_id) {
      __typename

      ... on ExhibitionCategory {
        id
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
